import { gql } from "@apollo/client"

export const UpdateClient = gql`
mutation UpdateClient($updateClientId: ID!, $content: contentClient!) {
  updateClient(id: $updateClientId, content: $content) {
    status
  }
}
`